import React from 'react';
import PropTypes from 'prop-types';
import styles from './Fade.css';

const DEFAULT_DURATION = 300;

function Fade({ children, duration = DEFAULT_DURATION }) {
    return (
        <div className={styles.root} style={{ animationDuration: `${duration}ms` }}>
            {children}
        </div>
    );
}

Fade.propTypes = {
    children: PropTypes.any.isRequired,
    duration: PropTypes.number
};

export {
    Fade
};
